import { Component } from '@angular/core';

@Component({
    template: require('./sample.rating.component.html')
})
export class RatingSampleComponent {
starsCount: number;
starsCounts: number[] = [];

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/samples/sample.rating/sample.rating.component.ts